const Home=()=>{
    return(
        <div className="container mt-5">
            <h1>BIENVENUE</h1>
        </div>
    );
}
export default Home;